import { render, staticRenderFns } from "./BAutocompleteStorageType.vue?vue&type=template&id=24067653&"
import script from "./BAutocompleteStorageType.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteStorageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports